import $ from 'jquery';
import 'slick-carousel'


let observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            let banner;
            try {
                banner = JSON.parse(entry.target.dataset.trackBanner);
            } catch (e) {
                console.warn(e);
                return;
            }

            //console.log('TRACK:', banner);
            window.dataLayer.push({
                'event': 'banner',
                'banner': `${banner.uid} - ${banner.name}`,
            });
            observer.unobserve(entry.target);
        }
    });
});

window.observeTrackBanners = (root) => {
    window.dataLayer = window.dataLayer || [];
    const $root = $(root || document.body);
    $root.find('*[data-track-banner]').each((index, element) => {
        observer.observe(element);
    });
}

$(window).on('load', window.observeTrackBanners);


// superbanner
$('.superbanner').each(function () {
    const $parent = $(this);
    const $slider = $parent.find('.superbanner__slider');
    const items = $slider.find('.superbanner__item').length;

    $slider.on('init', function () {
        window.observeTrackBanners($slider)
    });

    $slider.slick({
        autoplay: true,
        autoplaySpeed: 7000,
        infinite: true,
        arrows: false,
        dots: false,
        draggable: true,
        rows: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: Math.floor(Math.random() * items),
    });

});
